import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableHeader } from '../tableConfig';
import withImageSlider from '../../../../../utils/composition/withImageSlider';
import SplitPayment from '../../../../components/SplitPayment';
import { Pagination } from '../../../../../v4/components';
import withErrorAndLoadingScreen from '../../../../../utils/composition/withLoading';
import ReportTableStyled from '../../../../reports/ReportTableStyled';
import { dataProps, paginationProps } from '../../../../../data/enums/Component';

const propTypes = {
  tableConfig: PropTypes.arrayOf(Object).isRequired,
  dishonore: dataProps.value,
  onPageChange: PropTypes.func,
  pagination: paginationProps.value,
  handleSliderOpen: PropTypes.func.isRequired,
};

const defaultProps = {
  dishonore: dataProps.defaultValue,
  onPageChange: () => null,
  pagination: paginationProps.defaultValue,
};

class Dishonored extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialog: {
        type: '',
        element: '',
      },
    };
  }

  handleIconClick = (type, element = {}) => {
    this.setState({
      dialog: {
        type,
        element,
      },
    });
  };

  resetDialog = () => {
    this.setState({
      dialog: {
        type: '',
        element: '',
      },
    });
  };

  render() {
    const { dialog } = this.state;
    const { type } = dialog;
    const { tableConfig, dishonore, pagination, onPageChange, handleSliderOpen, permission } = this.props;
    return (
      <Fragment>
        <ReportTableStyled>
          {type && <SplitPayment data={dialog.element} type={type} resetDialog={this.resetDialog} />}
          <div className="table-wrap">
            <table>
              {TableHeader({
                tableConfig,
              })}

              <tbody>
                {dishonore.list.map(dishonored =>
                  TableBody({
                    data: dishonored,
                    onIconClick: this.handleIconClick,
                    tableConfig,
                    handleSliderOpen,
                    section: 'dishonored',
                    permission,
                  }),
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={pagination.page}
            limit={pagination.limit}
            totalItems={dishonore.total}
            onPageChange={onPageChange}
          />
        </ReportTableStyled>
      </Fragment>
    );
  }
}

Dishonored.propTypes = propTypes;

Dishonored.defaultProps = defaultProps;

const DishonoredWithErrorAndLoading = withErrorAndLoadingScreen(Dishonored);

const DishonoredWithImageSlider = withImageSlider(DishonoredWithErrorAndLoading);

export default DishonoredWithImageSlider;
